import { useUserPreferences } from "@/context/UserPreferencesContext";
import { getDateDisplayParts } from "@/lib/weekDates";

interface FormattedDateProps {
  value?: string | null;
  /** `stacked` — date on one line, week below (tables). `inline` — single line with · separator. */
  layout?: "stacked" | "inline";
}

export function FormattedDate({
  value,
  layout = "stacked",
}: FormattedDateProps) {
  const showWeek = useUserPreferences().preferences.showWeekNumbers;
  const parts = getDateDisplayParts(value, showWeek);

  if (parts.kind === "plain") {
    return <span className="whitespace-nowrap">{parts.text}</span>;
  }

  if (layout === "inline") {
    return (
      <span className="whitespace-nowrap">
        {parts.date} · {parts.week}
      </span>
    );
  }

  return (
    <span className="inline-flex flex-col leading-tight">
      <span>{parts.date}</span>
      <span>{parts.week}</span>
    </span>
  );
}
